export default function MarginHorizontalIcon() {
  return (
    <svg width='14' height='14' viewBox='0 0 14 14' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M1 13L1 1' stroke='#848484' />
      <path d='M13 13L13 1' stroke='#848484' />
      <path d='M9.5 4.5H4.5V9.5H9.5V4.5Z' stroke='#848484' />
    </svg>
  );
}
